import { Button, Icons, useToggle } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import { useEffect, useState } from 'react';
import { VerticalDrawer as VerticalDrawerNew } from '../../../components/vertical-drawer';
import { TWorkflowProcessDrawerProps } from './types';
import { WorkflowProcessParentSteps } from './WorkflowProcessParentSteps';

const WorkflowProcessDrawer = ({
  onClose,
  isShown,
  steps,
  activeParentStepId,
  setActiveParentStepId,
  header,
  hideHeader = false,
  alert,
  drawerClassName,
}: TWorkflowProcessDrawerProps) => {
  const [activeParentStep, setActiveParentStep] = useState(
    steps.find((step) => step.key === activeParentStepId) || steps[0]
  );

  const hideSideBarToggle = useToggle();

  useEffect(() => {
    setActiveParentStep(
      steps.find((step) => step.key === activeParentStepId) || steps[0]
    );
  }, [activeParentStepId, steps]);

  return (
    <VerticalDrawerNew
      isOpen={isShown}
      close={onClose}
      className={drawerClassName}
    >
      <div className="flex flex-col w-full h-screen overflow-hidden">
        <div className="py-3 px-6 gap-2 flex justify-between items-center border-b border-b-border-primary">
          {header}

          <Button variant="secondary" size="sm" onClick={onClose}>
            Save and exit
          </Button>
        </div>
        {alert}
        <div className="flex grow overflow-hidden">
          <div
            className={cn(
              'h-full relative',
              !hideSideBarToggle.value ? 'w-[320px]' : 'w-0'
            )}
          >
            <WorkflowProcessParentSteps
              steps={steps}
              hideHeader={hideHeader}
              activeStep={activeParentStep}
              setActiveStep={(step) => {
                setActiveParentStep(step);
                setActiveParentStepId(step.key);
              }}
            />
            <Button
              variant="tertiary"
              size="sm"
              onClick={hideSideBarToggle.toggle}
              className="absolute bottom-[50%] right-[-20px] rounded-full size-10 bg-bg-secondary"
            >
              {!hideSideBarToggle.value ? (
                <Icons.ChevronLeft className="size-4" />
              ) : (
                <Icons.ChevronRight className="size-4 relative left-2" />
              )}
            </Button>
          </div>
          <div className="flex-1 overflow-y-auto py-6 px-10 bg-bg-primary flex flex-col gap-16 h-full">
            {activeParentStep?.children || null}
          </div>
        </div>
      </div>
    </VerticalDrawerNew>
  );
};

export { WorkflowProcessDrawer };
